module.exports = __webpack_public_path__ + "img/sv11.a6c03f71.svg";